import { Component, OnInit, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CommonService } from '../../common.service';

@Component({
  selector: 'app-home',
  imports: [RouterLink],
  templateUrl: './home.html',
  styleUrl: './home.scss',
})
export class Home implements OnInit {
  private readonly commonService = inject(CommonService);

  ngOnInit(): void {
    // Home carries its own branding, so the shared header is hidden here.
    this.commonService.showHome();
  }
}
